
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { MinhaAgendaTransferenciaPesquisa } from '@app/models/minha-agenda-transferencia-pesquisa';

@Injectable()
export class MinhaAgendaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(minhaAgenda: MinhaAgenda): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'agenda/minha-agenda', minhaAgenda).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // alterar(minhaAgenda: MinhaAgenda) {
  //   return this.http.put(this.URL_API + "MinhaAgenda", minhaAgenda)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `agenda/minha-agenda/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/minha-agenda/${id}`);
  }

  obterTodos(
    buscarAgendaDeOutroUsuarioId: number = 0,
    trazerSomenteAtendimentos: boolean = false,
    exibirTodos: boolean = false): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/minha-agenda/obterTodos/?buscarAgendaDeOutroUsuarioId=${buscarAgendaDeOutroUsuarioId}
                                  &trazerSomenteAtendimentos=${trazerSomenteAtendimentos}
                                  &exibirTodos=${exibirTodos}`);
  }
  
  obterMinhaAgenda(tipo: string, dataInicial: string, dataFinal: string): Observable<any> {
    const data = { tipo, dataInicial, dataFinal };
    return this.http
      .post<any>(this.URL_API + `agenda/minha-agenda/obterMinhaAgenda`, JSON.stringify(data));
  }
  obterMinhaAgendaHome(tipo: string, dataInicial: string, dataFinal: string, exibirAtendimento: boolean = false, usuarioId: number): Observable<any> {
    const data = { tipo, dataInicial, dataFinal, exibirAtendimento, usuarioId };
    return this.http
      .post<any>(this.URL_API + `home/obterMinhaAgenda`, JSON.stringify(data));
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `agenda/minha-agenda/pesquisar/?descricao=${descricao}&pagina=${pagina}`);
  }

  obterPorProcesso(id: number, quantidade: number = 0): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/minha-agenda/ObterPorProcesso/?id=${id}`);
  }

  RealizarMinhaAgenda(agendaId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/minha-agenda/RealizarMinhaAgenda/?agendaId=${agendaId}`);
  }

  // transferencia de agenda
  obterMinhaAgendaTransferencia(pesquisa: MinhaAgendaTransferenciaPesquisa): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'agenda/transferencia-de-agenda/ObterMinhaAgendaTransferencia/', pesquisa, { headers: { meta: ['search'] }});
  }
  alterarUsuarioMinhaAgendaTransferencia(agendaId: number, usuarioNovoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API +
        `agenda/transferencia-de-agenda/AlterarUsuarioMinhaAgendaTransferencia/?agendaId=${agendaId}&usuarioNovoId=${usuarioNovoId}`);
  }

  // atendimento
  obterAtendimento(usuarioId: number, unidadeId: number | null, tipo: string, dataInicial: string, dataFinal: string): Observable<any> {
    const data = { usuarioId, unidadeId, tipo, dataInicial, dataFinal };
    return this.http
      .post<any>(this.URL_API + `agenda/atendimento/ObterAtendimento`, JSON.stringify(data));
  }

  cancelarAtendimento(agendaId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/atendimento/cancelarAtendimento/?agendaId=${agendaId}`);
  }
  iniciarAtendimento(agendaId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/atendimento/iniciarAtendimento/?agendaId=${agendaId}`);
  }
  finalizarAtendimento(agendaId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `agenda/atendimento/finalizarAtendimento/?agendaId=${agendaId}`);
  }

  deletarAtendimento(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `agenda/atendimento/${id}`);
  }

}
